module.exports = __webpack_public_path__ + "img/insta-social-icon.7825e94d.svg";